import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import WordToPDFUploadView from "./WordToPDFUploadView";
import { BASE_URL, MAX_UPLOAD_FILE_SIZE } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function WordToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Word To PDF Converter Online Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/word_to_pdf", title: "Convert Word To PDF Online" },
    data2: { link: "/word_to_pdf", title: "TXT, RTF, DOC, DOCX To PDF Online" },
    data3: { link: "/word_to_pdf", title: "MS Word To PDF Converter Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
        setProgress,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert Word to PDF online instantly. Turn DOC or DOCX files into high-quality PDFs quickly with our fast and secure Word to PDF converter."
      ></meta>
      <meta
        name="keywords"
        content="word to pdf, docx to pdf, doc to pdf, convert word to pdf, convert docx to pdf, online word to pdf, word pdf converter, docx pdf converter, word document to pdf, docx file to pdf, pdf converter online, free word to pdf, secure word to pdf, document to pdf converter, create pdf from word, msword to pdf, microsoft word to pdf converter, free word to pdf converter, pdf converter online, doc to pdf converter online, online document converter, doc to pdf free,"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Upload DOCX View */}
        {/* Upload View maxFileSize = 9.9mb */}
        {/* Runpod datauri size limit = .9mb */}
        {showEditFileScreen ? (
          <WordToPDFUploadView
            maxFileSize={MAX_UPLOAD_FILE_SIZE}
            allowedFileExtensions={["doc", "docx", "txt", "rtf"]}
          />
        ) : (
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "text/plain": [".txt"],
              "application/rtf": [".rtf"],
              "text/rtf": [".rtf"],
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                [".docx"],
              "application/msword": [".doc"],
              "application/doc": [".doc"],
              "application/ms-doc": [".doc"],
            }}
          />
        )}
        {/* Mid Section */}
        <MiscPageMidSection description="Our Word to PDF converter online website is a fast, secure, and reliable solution for converting Microsoft Word documents into high quality PDF files. Designed to support DOC and DOCX formats, this powerful Word to PDF online converter accurately preserves original text, fonts, images, tables, margins, and layout during conversion. Whether you are a student submitting assignments, a professional preparing reports, or a business sharing official documents, this convert Word to PDF online tool ensures your files look professional and consistent on every device. With a simple upload-and-convert process, users can transform Word files into universally compatible PDFs directly from their browser—no software installation required. Our Word document to PDF converter online creates print-ready, share-friendly PDF files that are ideal for emailing, downloading, archiving, and long-term storage. Strong security measures are in place to protect your documents, with files processed safely and automatically deleted after conversion to maintain privacy. By converting editable Word documents into fixed format PDFs, this tool prevents unwanted changes while improving accessibility and presentation quality. If you’re looking for a fast, accurate, and secure Word to PDF converter online that delivers professional results without formatting loss, this website is the perfect choice for all your document conversion needs." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Upload",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Word To PDF Converter"
          why_use={[
            {
              title: "Preserve Original Document Formatting",
              description:
                "This Word to PDF converter online keeps fonts, spacing, images, tables, and layout intact. When you convert Word to PDF online, your document looks consistent on all devices.",
            },

            {
              title: "Universal File Compatibility",
              description:
                "Using a convert Word to PDF online tool creates PDF files that can be opened on any operating system without requiring Microsoft Word software.",
            },

            {
              title: "Professional and Print Ready Output",
              description:
                "This Word document to PDF converter online generates clean, print ready PDFs ideal for reports, resumes, invoices, and official documents.",
            },

            {
              title: "Protect Documents from Unauthorized Editing",
              description:
                "Converting Word to PDF helps prevent unwanted changes. This secure Word to PDF online website ensures documents remain read only during sharing.",
            },

            {
              title: "No Software Installation Required",
              description:
                "Our browser based Word to PDF converter online allows users to convert DOC and DOCX files instantly without installing any software.",
            },

            {
              title: "Faster Workflow and Improved Productivity",
              description:
                "This fast convert Word to PDF online tool saves time by enabling quick document conversions for students, professionals, and businesses.",
            },

            {
              title: "Ideal for Business and Academic Use",
              description:
                "Our Word to PDF online converter is perfect for business reports, contracts, assignments, resumes, and academic submissions.",
            },

            {
              title: "Optimized File Size for Easy Sharing",
              description:
                "Our Word to PDF converter online creates optimized PDF files that are easy to email, upload, and store without losing quality.",
            },

            {
              title: "Reliable Long Term Archiving",
              description:
                "Converting Word to PDF online ensures documents remain stable and unchanged over time, making PDFs ideal for long term storage.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "How can I convert Word to PDF online for free?",
              description:
                "You can use ShivaPDF's Word to PDF tool to convert a Word document into a PDF file. Select your document, start the conversion, and download the resulting PDF when processing is complete.",
            },
            {
              title: "Is the Word to PDF converter free to use?",
              description:
                "ShivaPDF offers PDF tools designed to make document conversion simple. Check the Word to PDF page for current usage limits, supported file sizes, and any restrictions.",
            },
            {
              title: "Can I convert DOCX to PDF online?",
              description:
                "Yes, if DOCX is supported by the converter, you can transform a Microsoft Word DOCX document into a PDF that is convenient for sharing, printing, and viewing.",
            },
            {
              title: "Can I convert DOC files to PDF?",
              description:
                "If the tool supports the older DOC format, you can convert Word documents saved with the .doc extension into PDF files without manually recreating the document.",
            },
            {
              title: "Do I need Microsoft Word to convert Word to PDF?",
              description:
                "A compatible online Word to PDF converter can convert supported documents without requiring Microsoft Word to be installed on your device.",
            },
            {
              title: "Will my Word formatting be preserved after conversion?",
              description:
                "The converter aims to preserve the document's layout, fonts, images, tables, and paragraph formatting. Results may vary depending on the original document and the conversion engine.",
            },
            {
              title: "Will images and tables remain in the converted PDF?",
              description:
                "Images and tables can be included in the resulting PDF when supported by the conversion process. Review the converted file to confirm that complex layouts appear as expected.",
            },
            {
              title: "Can I convert a Word document with multiple pages to PDF?",
              description:
                "Yes, supported multi-page Word documents can be converted into PDF files with their page content and order retained, subject to the converter's limits.",
            },
            {
              title: "Can I convert Word to PDF without installing software?",
              description:
                "An online Word to PDF converter works through a compatible web browser, so you may not need to install a separate desktop application.",
            },
            {
              title: "Can I convert Word to PDF on my phone?",
              description:
                "If the tool supports your mobile browser, you can convert Word documents to PDF on a smartphone or tablet without needing a desktop computer.",
            },
            {
              title: "Can I convert Word to PDF on Mac or Windows?",
              description:
                "A browser-based converter can work on compatible Mac and Windows computers. Supported devices and browsers depend on the tool's requirements.",
            },
            {
              title: "Can I convert Word to PDF offline?",
              description:
                "An online converter generally needs an internet connection. Offline conversion is possible only if the tool specifically supports local processing and has the required resources available on your device.",
            },
            {
              title: "Does ShivaPDF process Word files locally?",
              description:
                "Local processing means a document is converted on your device rather than sent to a remote server. Check the tool's implementation and network behavior to confirm whether local conversion is supported.",
            },
            {
              title: "Are my Word documents safe during PDF conversion?",
              description:
                "File privacy depends on how the converter handles documents. Before converting sensitive files, review ShivaPDF's privacy policy and verify whether processing is local or server-based.",
            },
            {
              title: "Can I convert a password-protected Word document to PDF?",
              description:
                "A password-protected Word document may need to be unlocked before conversion. Support depends on the document's protection settings and the converter's capabilities.",
            },
            {
              title: "Can I convert a Word document containing hyperlinks?",
              description:
                "Hyperlinks may be preserved during conversion when supported by the conversion engine. Check the resulting PDF to ensure important links work correctly.",
            },
            {
              title: "Can I convert Word files containing charts and shapes to PDF?",
              description:
                "Charts, shapes, and other embedded objects may be retained if the converter supports them. Complex objects can render differently, so inspect the PDF after conversion.",
            },
            {
              title: "Why does my PDF look different from the original Word document?",
              description:
                "Layout differences can occur because of missing fonts, page settings, unsupported objects, or differences in document rendering. Check the original formatting and use commonly supported fonts if needed.",
            },
            {
              title: "Can I convert multiple Word files to PDF at once?",
              description:
                "Batch conversion depends on whether the tool supports selecting and processing multiple documents. Check the Word to PDF page for available multi-file options.",
            },
            {
              title: "Can I print my Word document after converting it to PDF?",
              description:
                "Yes, PDF is a convenient format for printing because it helps maintain a consistent page layout across compatible devices and PDF viewers.",
            },
            {
              title: "Does converting Word to PDF reduce file size?",
              description:
                "Conversion does not necessarily reduce file size. The resulting size depends on the document's text, images, embedded fonts, and the converter's output settings.",
            },
            {
              title: "Can I convert a Word document into a searchable PDF?",
              description:
                "Text-based Word documents generally produce PDFs with selectable and searchable text when the conversion process preserves text as PDF text rather than converting pages into images.",
            },
            {
              title: "What should I do if my Word to PDF conversion fails?",
              description:
                "Check that the file is supported, opens correctly, and is not corrupted or excessively large. Try saving it again in DOCX format or using a simpler document if the problem continues.",
            },
            {
              title: "Why should I convert Word documents to PDF?",
              description:
                "PDF files are useful for sharing, printing, archiving, and distributing documents while maintaining a consistent layout across different devices and operating systems.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default WordToPDFMain;
